import { useUpdateUserMembershipMutation } from '@/hooks/GQL';
import { useCustomDimensions } from '@edreamsodigeo/frontend-core';
import { useEffect } from 'react';
import {
  usePriceFreezeSession,
  PF_AUTO_RENEWAL,
} from '@/hooks/usePriceFreezeSession';

export function useRenewalAction({ onSuccess, onError }) {
  const { mutate, loading, errors } = useUpdateUserMembershipMutation({
    onSuccess,
    onError,
  });

  const activateRenewal = () => {
    mutate({ action: 'ACTIVATE_RENEWAL_STATUS' });
  };

  return { activateRenewal, loading, errors };
}

export function useAutoRenewalDimension() {
  const { update: updateDimensions } = useCustomDimensions();
  const [getSessionItem] = usePriceFreezeSession();
  const autorenewal = getSessionItem(PF_AUTO_RENEWAL);

  useEffect(() => {
    if (autorenewal === 'true') {
      updateDimensions({
        dimension88: 'autorenewal_on',
      });
    } else if (autorenewal === 'false') {
      updateDimensions({
        dimension88: 'autorenewal_off',
      });
    }
  }, [autorenewal, updateDimensions]);
}
